module.exports = __webpack_public_path__ + "static/media/294674.8f4844fa.png";